const countries = [
    { code: "AF", name: "Afghanistan", flag: "🇦🇫" },
    { code: "AL", name: "Albanie", flag: "🇦🇱" },
    { code: "DZ", name: "Algérie", flag: "🇩🇿" },
    { code: "AS", name: "Samoa américaines", flag: "🇦🇸" },
    { code: "AD", name: "Andorre", flag: "🇦🇩" },
    { code: "AO", name: "Angola", flag: "🇦🇴" },
    { code: "AI", name: "Anguilla", flag: "🇦🇮" },
    { code: "AQ", name: "Antarctique", flag: "🇦🇶" },
    { code: "AG", name: "Antigua-et-Barbuda", flag: "🇦🇬" },
    { code: "AR", name: "Argentine", flag: "🇦🇷" },
    { code: "AM", name: "Arménie", flag: "🇦🇲" },
    { code: "AW", name: "Aruba", flag: "🇦🇼" },
    { code: "AU", name: "Australie", flag: "🇦🇺" },
    { code: "AT", name: "Autriche", flag: "🇦🇹" },
    { code: "AZ", name: "Azerbaïdjan", flag: "🇦🇿" },
    { code: "BS", name: "Bahamas", flag: "🇧🇸" },
    { code: "BH", name: "Bahreïn", flag: "🇧🇭" },
    { code: "BD", name: "Bangladesh", flag: "🇧🇩" },
    { code: "BB", name: "Barbade", flag: "🇧🇧" },
    { code: "BY", name: "Biélorussie", flag: "🇧🇾" },
    { code: "BE", name: "Belgique", flag: "🇧🇪" },
    { code: "BZ", name: "Belize", flag: "🇧🇿" },
    { code: "BJ", name: "Bénin", flag: "🇧🇯" },
    { code: "BM", name: "Bermudes", flag: "🇧🇲" },
    { code: "BT", name: "Bhoutan", flag: "🇧🇹" },
    { code: "BO", name: "Bolivie", flag: "🇧🇴" },
    { code: "BQ", name: "Pays-Bas caribéens", flag: "🇧🇶" },
    { code: "BA", name: "Bosnie-Herzégovine", flag: "🇧🇦" },
    { code: "BW", name: "Botswana", flag: "🇧🇼" },
    { code: "BV", name: "Île Bouvet", flag: "🇧🇻" },
    { code: "BR", name: "Brésil", flag: "🇧🇷" },
    { code: "IO", name: "Territoire britannique de l'océan Indien", flag: "🇮🇴" },
    { code: "BN", name: "Brunei", flag: "🇧🇳" },
    { code: "BG", name: "Bulgarie", flag: "🇧🇬" },
    { code: "BF", name: "Burkina Faso", flag: "🇧🇫" },
    { code: "BI", name: "Burundi", flag: "🇧🇮" },
    { code: "CV", name: "Cap-Vert", flag: "🇨🇻" },
    { code: "KH", name: "Cambodge", flag: "🇰🇭" },
    { code: "CM", name: "Cameroun", flag: "🇨🇲" },
    { code: "CA", name: "Canada", flag: "🇨🇦" },
    { code: "KY", name: "Îles Caïmans", flag: "🇰🇾" },
    { code: "CF", name: "République centrafricaine", flag: "🇨🇫" },
    { code: "TD", name: "Tchad", flag: "🇹🇩" },
    { code: "CL", name: "Chili", flag: "🇨🇱" },
    { code: "CN", name: "Chine", flag: "🇨🇳" },
    { code: "CX", name: "Île Christmas", flag: "🇨🇽" },
    { code: "CC", name: "Îles Cocos", flag: "🇨🇨" },
    { code: "CO", name: "Colombie", flag: "🇨🇴" },
    { code: "KM", name: "Comores", flag: "🇰🇲" },
    { code: "CG", name: "Congo-Brazzaville", flag: "🇨🇬" },
    { code: "CD", name: "Congo-Kinshasa", flag: "🇨🇩" },
    { code: "CK", name: "Îles Cook", flag: "🇨🇰" },
    { code: "CR", name: "Costa Rica", flag: "🇨🇷" },
    { code: "HR", name: "Croatie", flag: "🇭🇷" },
    { code: "CU", name: "Cuba", flag: "🇨🇺" },
    { code: "CW", name: "Curaçao", flag: "🇨🇼" },
    { code: "CY", name: "Chypre", flag: "🇨🇾" },
    { code: "CZ", name: "Tchéquie", flag: "🇨🇿" },
    { code: "DK", name: "Danemark", flag: "🇩🇰" },
    { code: "DJ", name: "Djibouti", flag: "🇩🇯" },
    { code: "DM", name: "Dominique", flag: "🇩🇲" },
    { code: "DO", name: "République dominicaine", flag: "🇩🇴" },
    { code: "EC", name: "Équateur", flag: "🇪🇨" },
    { code: "EG", name: "Égypte", flag: "🇪🇬" },
    { code: "SV", name: "Salvador", flag: "🇸🇻" },
    { code: "GQ", name: "Guinée équatoriale", flag: "🇬🇶" },
    { code: "ER", name: "Érythrée", flag: "🇪🇷" },
    { code: "EE", name: "Estonie", flag: "🇪🇪" },
    { code: "ET", name: "Éthiopie", flag: "🇪🇹" },
    { code: "FK", name: "Îles Malouines", flag: "🇫🇰" },
    { code: "FO", name: "Îles Féroé", flag: "🇫🇴" },
    { code: "FJ", name: "Fidji", flag: "🇫🇯" },
    { code: "FI", name: "Finlande", flag: "🇫🇮" },
    { code: "FR", name: "France", flag: "🇫🇷" },
    { code: "GF", name: "Guyane française", flag: "🇬🇫" },
    { code: "PF", name: "Polynésie française", flag: "🇵🇫" },
    { code: "TF", name: "Terres australes françaises", flag: "🇹🇫" },
    { code: "GA", name: "Gabon", flag: "🇬🇦" },
    { code: "GM", name: "Gambie", flag: "🇬🇲" },
    { code: "GE", name: "Géorgie", flag: "🇬🇪" },
    { code: "DE", name: "Allemagne", flag: "🇩🇪" },
    { code: "GH", name: "Ghana", flag: "🇬🇭" },
    { code: "GI", name: "Gibraltar", flag: "🇬🇮" },
    { code: "GR", name: "Grèce", flag: "🇬🇷" },
    { code: "GL", name: "Groenland", flag: "🇬🇱" },
    { code: "GD", name: "Grenade", flag: "🇬🇩" },
    { code: "GP", name: "Guadeloupe", flag: "🇬🇵" },
    { code: "GU", name: "Guam", flag: "🇬🇺" },
    { code: "GT", name: "Guatemala", flag: "🇬🇹" },
    { code: "GG", name: "Guernesey", flag: "🇬🇬" },
    { code: "GN", name: "Guinée", flag: "🇬🇳" },
    { code: "GW", name: "Guinée-Bissau", flag: "🇬🇼" },
    { code: "GY", name: "Guyana", flag: "🇬🇾" },
    { code: "HT", name: "Haïti", flag: "🇭🇹" },
    { code: "HN", name: "Honduras", flag: "🇭🇳" },
    { code: "HK", name: "Hong Kong", flag: "🇭🇰" },
    { code: "HU", name: "Hongrie", flag: "🇭🇺" },
    { code: "IS", name: "Islande", flag: "🇮🇸" },
    { code: "IN", name: "Inde", flag: "🇮🇳" },
    { code: "ID", name: "Indonésie", flag: "🇮🇩" },
    { code: "IR", name: "Iran", flag: "🇮🇷" },
    { code: "IQ", name: "Irak", flag: "🇮🇶" },
    { code: "IE", name: "Irlande", flag: "🇮🇪" },
    { code: "IM", name: "Île de Man", flag: "🇮🇲" },
    { code: "IL", name: "Israël", flag: "🇮🇱" },
    { code: "IT", name: "Italie", flag: "🇮🇹" },
    { code: "JM", name: "Jamaïque", flag: "🇯🇲" },
    { code: "JP", name: "Japon", flag: "🇯🇵" },
    { code: "JE", name: "Jersey", flag: "🇯🇪" },
    { code: "JO", name: "Jordanie", flag: "🇯🇴" },
    { code: "KZ", name: "Kazakhstan", flag: "🇰🇿" },
    { code: "KE", name: "Kenya", flag: "🇰🇪" },
    { code: "KI", name: "Kiribati", flag: "🇰🇮" },
    { code: "KP", name: "Corée du Nord", flag: "🇰🇵" },
    { code: "KR", name: "Corée du Sud", flag: "🇰🇷" },
    { code: "KW", name: "Koweït", flag: "🇰🇼" },
    { code: "KG", name: "Kirghizistan", flag: "🇰🇬" },
    { code: "LA", name: "Laos", flag: "🇱🇦" },
    { code: "LV", name: "Lettonie", flag: "🇱🇻" },
    { code: "LB", name: "Liban", flag: "🇱🇧" },
    { code: "LS", name: "Lesotho", flag: "🇱🇸" },
    { code: "LR", name: "Libéria", flag: "🇱🇷" },
    { code: "LY", name: "Libye", flag: "🇱🇾" },
    { code: "LI", name: "Liechtenstein", flag: "🇱🇮" },
    { code: "LT", name: "Lituanie", flag: "🇱🇹" },
    { code: "LU", name: "Luxembourg", flag: "🇱🇺" },
    { code: "MO", name: "Macao", flag: "🇲🇴" },
    { code: "MG", name: "Madagascar", flag: "🇲🇬" },
    { code: "MW", name: "Malawi", flag: "🇲🇼" },
    { code: "MY", name: "Malaisie", flag: "🇲🇾" },
    { code: "MV", name: "Maldives", flag: "🇲🇻" },
    { code: "ML", name: "Mali", flag: "🇲🇱" },
    { code: "MT", name: "Malte", flag: "🇲🇹" },
    { code: "MH", name: "Îles Marshall", flag: "🇲🇭" },
    { code: "MQ", name: "Martinique", flag: "🇲🇶" },
    { code: "MR", name: "Mauritanie", flag: "🇲🇷" },
    { code: "MU", name: "Maurice", flag: "🇲🇺" },
    { code: "YT", name: "Mayotte", flag: "🇾🇹" },
    { code: "MX", name: "Mexique", flag: "🇲🇽" },
    { code: "FM", name: "Micronésie", flag: "🇫🇲" },
    { code: "MD", name: "Moldavie", flag: "🇲🇩" },
    { code: "MC", name: "Monaco", flag: "🇲🇨" },
    { code: "MN", name: "Mongolie", flag: "🇲🇳" },
    { code: "ME", name: "Monténégro", flag: "🇲🇪" },
    { code: "MS", name: "Montserrat", flag: "🇲🇸" },
    { code: "MA", name: "Maroc", flag: "🇲🇦" },
    { code: "MZ", name: "Mozambique", flag: "🇲🇿" },
    { code: "MM", name: "Myanmar", flag: "🇲🇲" },
    { code: "NA", name: "Namibie", flag: "🇳🇦" },
    { code: "NR", name: "Nauru", flag: "🇳🇷" },
    { code: "NP", name: "Népal", flag: "🇳🇵" },
    { code: "NL", name: "Pays-Bas", flag: "🇳🇱" },
    { code: "NC", name: "Nouvelle-Calédonie", flag: "🇳🇨" },
    { code: "NZ", name: "Nouvelle-Zélande", flag: "🇳🇿" },
    { code: "NI", name: "Nicaragua", flag: "🇳🇮" },
    { code: "NE", name: "Niger", flag: "🇳🇪" },
    { code: "NG", name: "Nigéria", flag: "🇳🇬" },
    { code: "NU", name: "Niue", flag: "🇳🇺" },
    { code: "NF", name: "Île Norfolk", flag: "🇳🇫" },
    { code: "MP", name: "Îles Mariannes du Nord", flag: "🇲🇵" },
    { code: "NO", name: "Norvège", flag: "🇳🇴" },
    { code: "OM", name: "Oman", flag: "🇴🇲" },
    { code: "PK", name: "Pakistan", flag: "🇵🇰" },
    { code: "PW", name: "Palaos", flag: "🇵🇼" },
    { code: "PS", name: "Palestine", flag: "🇵🇸" },
    { code: "PA", name: "Panama", flag: "🇵🇦" },
    { code: "PG", name: "Papouasie-Nouvelle-Guinée", flag: "🇵🇬" },
    { code: "PY", name: "Paraguay", flag: "🇵🇾" },
    { code: "PE", name: "Pérou", flag: "🇵🇪" },
    { code: "PH", name: "Philippines", flag: "🇵🇭" },
    { code: "PL", name: "Pologne", flag: "🇵🇱" },
    { code: "PT", name: "Portugal", flag: "🇵🇹" },
    { code: "PR", name: "Porto Rico", flag: "🇵🇷" },
    { code: "QA", name: "Qatar", flag: "🇶🇦" },
    { code: "RE", name: "La Réunion", flag: "🇷🇪" },
    { code: "RO", name: "Roumanie", flag: "🇷🇴" },
    { code: "RU", name: "Russie", flag: "🇷🇺" },
    { code: "RW", name: "Rwanda", flag: "🇷🇼" },
    { code: "BL", name: "Saint-Barthélemy", flag: "🇧🇱" },
    { code: "SH", name: "Sainte-Hélène", flag: "🇸🇭" },
    { code: "KN", name: "Saint-Christophe-et-Niévès", flag: "🇰🇳" },
    { code: "LC", name: "Sainte-Lucie", flag: "🇱🇨" },
    { code: "MF", name: "Saint-Martin", flag: "🇲🇫" },
    { code: "PM", name: "Saint-Pierre-et-Miquelon", flag: "🇵🇲" },
    { code: "VC", name: "Saint-Vincent-et-les-Grenadines", flag: "🇻🇨" },
    { code: "WS", name: "Samoa", flag: "🇼🇸" },
    { code: "SM", name: "Saint-Marin", flag: "🇸🇲" },
    { code: "ST", name: "Sao Tomé-et-Principe", flag: "🇸🇹" },
    { code: "SA", name: "Arabie saoudite", flag: "🇸🇦" },
    { code: "SN", name: "Sénégal", flag: "🇸🇳" },
    { code: "RS", name: "Serbie", flag: "🇷🇸" },
    { code: "SC", name: "Seychelles", flag: "🇸🇨" },
    { code: "SL", name: "Sierra Leone", flag: "🇸🇱" },
    { code: "SG", name: "Singapour", flag: "🇸🇬" },
    { code: "SX", name: "Saint-Martin (partie néerlandaise)", flag: "🇸🇽" },
    { code: "SK", name: "Slovaquie", flag: "🇸🇰" },
    { code: "SI", name: "Slovénie", flag: "🇸🇮" },
    { code: "SB", name: "Îles Salomon", flag: "🇸🇧" },
    { code: "SO", name: "Somalie", flag: "🇸🇴" },
    { code: "ZA", name: "Afrique du Sud", flag: "🇿🇦" },
    { code: "GS", name: "Géorgie du Sud et îles Sandwich", flag: "🇬🇸" },
    { code: "SS", name: "Soudan du Sud", flag: "🇸🇸" },
    { code: "ES", name: "Espagne", flag: "🇪🇸" },
    { code: "LK", name: "Sri Lanka", flag: "🇱🇰" },
    { code: "SD", name: "Soudan", flag: "🇸🇩" },
    { code: "SR", name: "Suriname", flag: "🇸🇷" },
    { code: "SJ", name: "Svalbard et Jan Mayen", flag: "🇸🇯" },
    { code: "SE", name: "Suède", flag: "🇸🇪" },
    { code: "CH", name: "Suisse", flag: "🇨🇭" },
    { code: "SY", name: "Syrie", flag: "🇸🇾" },
    { code: "TW", name: "Taïwan", flag: "🇹🇼" },
    { code: "TJ", name: "Tadjikistan", flag: "🇹🇯" },
    { code: "TZ", name: "Tanzanie", flag: "🇹🇿" },
    { code: "TH", name: "Thaïlande", flag: "🇹🇭" },
    { code: "TL", name: "Timor oriental", flag: "🇹🇱" },
    { code: "TG", name: "Togo", flag: "🇹🇬" },
    { code: "TK", name: "Tokelau", flag: "🇹🇰" },
    { code: "TO", name: "Tonga", flag: "🇹🇴" },
    { code: "TT", name: "Trinité-et-Tobago", flag: "🇹🇹" },
    { code: "TN", name: "Tunisie", flag: "🇹🇳" },
    { code: "TR", name: "Turquie", flag: "🇹🇷" },
    { code: "TM", name: "Turkménistan", flag: "🇹🇲" },
    { code: "TC", name: "Îles Turques-et-Caïques", flag: "🇹🇨" },
    { code: "TV", name: "Tuvalu", flag: "🇹🇻" },
    { code: "UG", name: "Ouganda", flag: "🇺🇬" },
    { code: "UA", name: "Ukraine", flag: "🇺🇦" },
    { code: "AE", name: "Émirats arabes unis", flag: "🇦🇪" },
    { code: "GB", name: "Royaume-Uni", flag: "🇬🇧" },
    { code: "US", name: "États-Unis", flag: "🇺🇸" },
    { code: "UY", name: "Uruguay", flag: "🇺🇾" },
    { code: "UZ", name: "Ouzbékistan", flag: "🇺🇿" },
    { code: "VU", name: "Vanuatu", flag: "🇻🇺" },
    { code: "VA", name: "Vatican", flag: "🇻🇦" },
    { code: "VE", name: "Venezuela", flag: "🇻🇪" },
    { code: "VN", name: "Viêt Nam", flag: "🇻🇳" },
    { code: "VG", name: "Îles Vierges britanniques", flag: "🇻🇬" },
    { code: "VI", name: "Îles Vierges des États-Unis", flag: "🇻🇮" },
    { code: "WF", name: "Wallis-et-Futuna", flag: "🇼🇫" },
    { code: "EH", name: "Sahara occidental", flag: "🇪🇭" },
    { code: "YE", name: "Yémen", flag: "🇾🇪" },
    { code: "ZM", name: "Zambie", flag: "🇿🇲" },
    { code: "ZW", name: "Zimbabwe", flag: "🇿🇼" },
];
  
export default countries;
  